var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecovrLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 654.3 205.4",
    style: {
      enableBackground: "new 0 0 654.3 205.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#004A7C;}\r\n\t.st1{fill:#2CE1BE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.7,80.1v9.2c-9-0.5-14.7,4.8-15.4,12.4V125h-9.6V80.4h9.6v8.9C259.3,83.3,264.7,80.1,271.7,80.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.8,106.4h-33.7c1.5,6.9,6.8,11.2,13.8,11.2c4.9,0,9.3-1.8,12.6-5.2l5.1,5.5c-4.4,4.8-10.7,7.6-18.5,7.6 c-13.7,0-22.8-9.1-22.8-22.6c0-13.5,9.3-22.6,22.6-22.7C345.6,80.1,352,90.3,350.8,106.4z M342.4,99.4 c-0.3-7.2-5.1-11.6-12.4-11.6c-7,0-12.1,4.4-13.1,11.6H342.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.4,88.5c-7.7,0-13.2,5.8-13.2,14.3c0,8.5,5.5,14.3,13.2,14.3c5.6,0,10.2-1.8,13.2-5.4l5.4,5.4 c-4,5.3-10.5,8.3-19,8.3c-13.2,0-22.5-9.1-22.5-22.6c0-13.5,9.2-22.7,22.5-22.7c8.1,0,14.4,2.6,18.5,7.3l-5.3,6.2 C421.1,90.4,416.8,88.5,411.4,88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512.5,102.7c0,13.4-9.5,22.6-23.2,22.6c-13.8,0-23.3-9.2-23.3-22.6c0-13.5,9.5-22.6,23.3-22.6 C503,80.1,512.5,89.2,512.5,102.7z M475.6,102.8c0,8.6,5.6,14.5,13.7,14.5c8,0,13.6-5.9,13.6-14.5c0-8.5-5.6-14.4-13.6-14.4 C481.2,88.4,475.6,94.2,475.6,102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M555.8,80.4l12.4,35.1l12.2-35.1h9.6L573,125h-10l-17.3-44.6H555.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M654.3,80.1v9.2c-9-0.5-14.7,4.8-15.4,12.4V125h-9.6V80.4h9.6v8.9C641.9,83.3,647.2,80.1,654.3,80.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,149.9c0-6.2,5.1-11.3,11.3-11.3c6.3,0,11.3,5.1,11.3,11.3c0,6.3-5.1,11.3-11.3,11.3 C5.1,161.2,0,156.1,0,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.8,149.9c0-7.4,6-13.4,13.4-13.4c7.4,0,13.4,6,13.4,13.4c0,7.4-6,13.4-13.4,13.4 C163.8,163.3,157.8,157.3,157.8,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.9,57.1c0-5.2,4.2-9.4,9.4-9.4c5.2,0,9.5,4.2,9.5,9.4c0,5.2-4.2,9.4-9.5,9.4C6.1,66.6,1.9,62.3,1.9,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.9,57.1c0-6.3,5.1-11.3,11.3-11.3c6.2,0,11.3,5.1,11.3,11.3c0,6.2-5.1,11.3-11.3,11.3 C165,68.4,159.9,63.4,159.9,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.3,103.7c0-9.4,7.6-17,17-17c9.4,0,17,7.6,17,17c0,9.4-7.6,17-17,17C81.9,120.6,74.3,113,74.3,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80,11.3C80,5.1,85,0,91.3,0c6.2,0,11.3,5.1,11.3,11.3c0,6.3-5.1,11.3-11.3,11.3C85,22.6,80,17.6,80,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.9,196c0-5.2,4.2-9.4,9.4-9.4c5.2,0,9.4,4.2,9.4,9.4c0,5.2-4.2,9.4-9.4,9.4C86.1,205.4,81.9,201.2,81.9,196 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.1,79.4V29.8c-1.2,0.2-2.5,0.4-3.8,0.4c-1.3,0-2.5-0.1-3.8-0.4v49.6c1.2-0.2,2.5-0.3,3.8-0.3 C92.6,79.1,93.8,79.2,95.1,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.3,88.1c1.6,2,2.9,4.2,3.8,6.5l43.1-25c-1.7-1.9-3-4.1-3.8-6.5L110.3,88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.1,112.5c-0.9,2.4-2.2,4.6-3.8,6.5l41.1,23.8c0.9-2.4,2.2-4.6,3.8-6.5L114.1,112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.4,112.4l-43,25c1.7,1.9,3,4.1,3.8,6.5l43-24.9C70.6,117,69.3,114.8,68.4,112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.3,23.8l48,27.7c0.8-2.5,2-4.7,3.7-6.6l-47.9-27.6C108.3,19.7,107,21.9,105.3,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.9,184.5l-49.7-28.7c-0.8,2.5-2.1,4.7-3.8,6.6L75.1,191C75.9,188.5,77.2,186.3,78.9,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.5,156.9l-47.8,27.6c1.7,1.8,3,4.1,3.8,6.5l47.8-27.6C153.6,161.5,152.4,159.3,151.5,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.2,76c-1.3,0-2.6-0.1-3.8-0.4v53.6c1.2-0.2,2.5-0.4,3.8-0.4c1.3,0,2.6,0.1,3.8,0.4V75.6 C173.8,75.9,172.5,76,171.2,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.6,52.5l49.6-28.7c-1.7-1.9-2.9-4.1-3.8-6.5L23.9,45.9C25.6,47.7,26.9,50,27.6,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.3,131c1.3,0,2.6,0.1,3.8,0.4V73.7c-1.2,0.3-2.5,0.5-3.8,0.5c-1.3,0-2.5-0.2-3.8-0.5v57.7 C8.8,131.1,10,131,11.3,131z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecovrLogo);
export default __webpack_public_path__ + "static/media/recovr-logo.f3e7ab92faf2c58c18b64b6ac67074af.svg";
export { ForwardRef as ReactComponent };